/**
 * Audit Logs Service
 * Handles API calls for audit logs retrieval and filtering
 */
import { apiGet } from './api';

export interface AuditLog {
  auditLogID: number;
  eventTimestamp: string;
  userID: number;
  userEmail: string;
  userRole: string;
  userName: string;
  actionType: string;
  resourceType: string;
  resourceID: number | null;
  ipAddress: string | null;
  userAgent: string | null;
  requestMethod: string | null;
  requestURL: string | null;
  success: boolean;
  errorMessage: string | null;
  details: string | null;
}

export interface AuditLogsResponse {
  logs: AuditLog[];
  pagination: {
    total: number;
    limit: number;
    offset: number;
  };
}

export interface AuditLogsFilters {
  userId?: number;
  actionType?: string;
  resourceType?: string;
  startDate?: string;
  endDate?: string;
  success?: boolean;
  limit?: number;
  offset?: number;
}

/**
 * Get audit logs with optional filtering and pagination
 */
export async function getAuditLogs(filters?: AuditLogsFilters): Promise<AuditLogsResponse> {
  const response = await apiGet<AuditLogsResponse>('/audit-logs', filters);

  if (!response.success) {
    const errorMsg = `Failed to fetch audit logs: ${response.error?.message || 'Unknown error'}`;
    console.error(errorMsg, response.error);
    throw new Error(errorMsg);
  }

  return response.data || { logs: [], pagination: { total: 0, limit: 100, offset: 0 } };
}
